import i18n from '../../../language/i18n'

const DATA_TYPES = Object.freeze({
    STRING: {value: 'STRING', text: i18n.t('Common.text'), hasMultipleValuesSelect: true, component: 'w-form-text-field', key: 'stringValue' },
    BOOLEAN: {value: 'BOOLEAN', text: i18n.t('ProductAttributes.words.yesNoVariable'), hasMultipleValuesSelect: false, component: 'w-form-text-field', key: 'booleanValue'},
    INTEGER: { value: 'INTEGER', text: i18n.t('ProductAttributes.words.integer'), hasMultipleValuesSelect: false, component: 'w-form-number-text-field', key: 'integerValue' },
    BIG_DECIMAL: { value: 'BIG_DECIMAL', text: i18n.t('ProductAttributes.words.decimal'), hasMultipleValuesSelect: false, component: 'w-form-decimal-text-field', key: 'decimalValue' },
});

export default DATA_TYPES;
